import { api } from 'data/api/api'

import type {
  CreateUser2FAArgs,
  CreateUser2FAResp,
  GetTwoFADetailsResp,
} from '../types/verification'

export const createUser2FA = (args: CreateUser2FAArgs) =>
  api.post<CreateUser2FAResp>(
    `/users/${args.userId}/user_2fa`,
    {
      entity_id: args.entityId,
      type: args.entityType,
      fingerprint: args.fingerprint,
    },
    { params: { phone_number: args.number } },
  )

export const getTwoFADetails = (twoFaId: string) =>
  api.get<GetTwoFADetailsResp>(`user_verifier/${twoFaId}/details`)
